import get from 'lodash/get';
import map from 'lodash/map';
import {
    IUserStats,
    IDashboardData,
    ISkillProgress,
    IRecentActivity,
    IStudyGoal,
    ILearningPath,
    IAiLesson,
} from './interfaces';

export const convertToUserStats = (data: any): IUserStats => {
    return {
        totalCompletedLessons: get(data, 'total_lessons_completed', 0) || 0,
        totalLessons: get(data, 'total_lessons', 0) || 0,
        totalStudyHours: get(data, 'total_study_time_hours', 0) || 0,
        studyTimeDisplay: get(data, 'study_time_display', '') || '',
        overallProgressPercentage: get(data, 'overall_progress_percentage', 0) || 0,
        currentStreak: get(data, 'current_streak', 0) || 0,
        currentLevelDisplay: get(data, 'current_level_display', '') || '',
    };
};

export const convertToAiLesson = (data: any): IAiLesson => {
    const attemptsCount = get(data, 'attempts_count', 0) || 0;
    const estimatedDuration = get(data, 'estimated_duration', '00:00:00') || '00:00:00';
    const [hours, minutes, seconds] = estimatedDuration.split(':').map(Number);
    const totalMinutes = hours * 60 + minutes + seconds / 60;
    return {
        id: get(data, 'ai_lesson', '') || '',
        title: get(data, 'title', '') || '',
        types: get(data, 'skill') ? [get(data, 'skill', '')] : get(data, 'forcus', []),
        duration: totalMinutes,
        progress: get(data, 'completion_percentage', 0) || 0,
        isNew: attemptsCount > 0 ? false : true,
    };
};

export const convertToSkillProgress = (data: any): ISkillProgress => {
    return {};
};
export const convertToRecentActivity = (data: any): IRecentActivity => {
    return {};
};
export const convertToStudyGoal = (data: any): IStudyGoal => {
    return {};
};
export const convertToLearningPath = (data: any): ILearningPath => {
    return {};
};

export const convertToDashboardData = (data: any): IDashboardData => {
    const userStats = get(data, 'dashboard_stats', null);
    const skillProgress = get(data, 'skillProgress', null);
    const skillProgressOverview = get(data, 'skill_progress_overview', null);
    const recentActivities = get(data, 'recentActivity', null);
    const studyGoals = get(data, 'studyGoals', null);
    const learningPaths = get(data, 'learningPaths', null);
    const weeklyReport = get(data, 'weeklyReport', null);
    const todaySchedule = get(data, 'today_schedule', null);
    const aiLessons = get(todaySchedule, 'lessons', null);
    return {
        userStats: userStats && convertToUserStats(userStats),
        skillProgress: (skillProgress && map(skillProgress, convertToSkillProgress)) || [],
        skillProgressOverview: skillProgressOverview || null,
        recentActivities: (recentActivities && map(recentActivities, convertToRecentActivity)) || [],
        studyGoals: (studyGoals && map(studyGoals, convertToStudyGoal)) || [],
        learningPaths: (learningPaths && map(learningPaths, convertToLearningPath)) || [],
        weeklyReport,
        todayAiLessons: (aiLessons && map(aiLessons, convertToAiLesson)) || [],
        scheduleId: todaySchedule.id,
    };
};
